import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { lighten } from "polished";
import * as Styled from "./LinearProgress.styled";
export const LinearProgress = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, color, id, height, palette = "expressiveInformative", value = 0, variant = "determinate", ...otherProps } = props;
    const isColorValid = (color) => {
        if (!color) {
            return false;
        }
        let isValid = true;
        /**
         * Need to catch an error if the color is not valid.
         * Will use the default base color if the color set by the user is not valid.
         */
        try {
            lighten(0.06, color);
        }
        catch (err) {
            console.error(err);
            isValid = false;
        }
        return isValid;
    };
    const scale = Math.max(0, Math.min(value, 1));
    const hasValidColor = isColorValid(color);
    const a11yProps = variant === "determinate"
        ? {
            "aria-valuenow": value,
            "aria-valuemin": 0,
            "aria-valuemax": 1
        }
        : {};
    return (_jsx(Styled.LinearProgress, { ref: ref, "data-testid": "LinearProgress", id: id, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, palette: palette, height: height, role: "progressbar", ...a11yProps, ...otherProps, children: _jsx(Styled.Line, { variant: variant, palette: palette, hasValidColor: hasValidColor, color: color, style: variant === "determinate" ? { width: `${scale * 100}%` } : undefined }) }));
});
LinearProgress.displayName = "LinearProgress";
LinearProgress.defaultProps = {
    palette: "expressiveInformative",
    value: 0,
    variant: "determinate"
};
